module.exports = __webpack_public_path__ + "img/北京库房.601a8c36.jpg";